import { z } from "zod";

export const impactSchema = z.object({
	id: z.number(),
	name: z.string(),
	description: z.string(),
	icon: z.string(),
});

export const companyDataSchema = z.object({
	_result: z.object({
		http_code: z.number(),
	}),
	data: z.object({
		impacts: z.object({
			working_days: z.object({
				id: z.number(),
				name: z.string(),
				description: z.string(),
				icon: z.string(),
			}),
			working_days_stat: z.number(),
			working_days_designated_projected_stat: z.number(),
			working_days_ordered_projected_stat: z.number(),
			working_days_projected_stat: z.number(),
			working_days_possible_stat: z.number(),
			ocean_area_planted: impactSchema,
			ocean_area_planted_stat: z.number(),
			ocean_area_planted_ordered_projected_stat: z.number(),
			ocean_area_planted_designated_projected_stat: z.number(),
			ocean_area_planted_possible_stat: z.number(),
			ocean_area_planted_projected_stat: z.number(),
			yield: impactSchema,
			yield_stat: z.number(),
			yield_projected_stat: z.number(),
			yield_designated_projected_stat: z.number(),
			yield_ordered_projected_stat: z.number(),
			yield_possible_stat: z.number(),
			co2: impactSchema,
			co2_stat: z.number(),
			co2_projected_stat: z.number(),
			co2_ordered_projected_stat: z.number(),
			co2_designated_projected_stat: z.number(),
			co2_possible_stat: z.number(),
			area_planted: impactSchema,
			area_planted_stat: z.number(),
			area_planted_ordered_projected_stat: z.number(),
			area_planted_designated_projected_stat: z.number(),
			area_planted_possible_stat: z.number(),
			area_planted_projected_stat: z.number(),
		}),
		countries: z.array(
			z.object({
				id: z.number(),
				name: z.string(),
				regions: z.array(
					z.object({
						id: z.number(),
						name: z.string(),
					}),
				),
			}),
		),
		trees_planted: z.number(),
		trees_ordered: z.number(),
		trees_designated: z.number(),
		trees_legacy: z.number(),
		trees_by_forest_types: z.array(
			z.object({
				forest_type_id: z.number(),
				type: z.union([z.literal("Trees"), z.literal("Kelp")]),
				trees_planted: z.number(),
				trees_ordered: z.number(),
				trees_designated: z.number(),
				trees_legacy: z.number(),
			}),
		),
		kelp_planted: z.number(),
		kelp_ordered: z.number(),
		kelp_designated: z.number(),
		kelp_legacy: z.number(),
	}),
	_org: z.object({
		id: z.number(),
		type: z.string(),
		user_id: z.null(),
		org_id: z.null(),
		name: z.string(),
		org: z.object({
			id: z.number(),
			public_id: z.string(),
			country_id: z.number(),
			name: z.string(),
			street: z.string(),
			city: z.string(),
			state: z.string(),
			postal_code: z.string(),
			phone: z.string(),
			fax: z.string(),
			active: z.number(),
			daily_auto_order_limit: z.string(),
			created_at: z.string(),
			updated_at: z.string(),
			claimed: z.number(),
			description: z.string(),
			private: z.boolean(),
			external_id: z.string(),
			notes: z.string(),
			logo: z.object({
				id: z.number(),
				url: z.string(),
				cdn_url: z.string(),
			}),
			org_type: z.string(),
			domain: z.string(),
		}),
	}),
	_view: z.object({
		id: z.null(),
		type: z.null(),
	}),
});

export type CompanyDataResponse = z.infer<typeof companyDataSchema>;
export type RawForestType =
	CompanyDataResponse["data"]["trees_by_forest_types"][number];

export type Country = CompanyDataResponse["data"]["countries"][number];
